export default "__VITE_ASSET__CLBtTUvj__$_?url__"